import { AppState } from 'stores/index'
import { ChoroplethMap } from 'components/choroplethMap/choroplethMapComponent'
import { connect } from 'react-redux'

function mapStateToProps ({ valuesByMunicipality, extents }: AppState) {
  return {
    currentExtents: extents,
    gemeinden: valuesByMunicipality
  }
}

const reduxConnectedChoroplethMap = connect(mapStateToProps)(ChoroplethMap)

export default reduxConnectedChoroplethMap
